"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBatchStatusIcon = exports.BATCH_STATUS_MAP = exports.BATCH_STATUS_ENUM = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var BATCH_STATUS_ENUM = exports.BATCH_STATUS_ENUM = {
  COMPLETED: 'COMPLETED',
  CONCLUDED: 'CONCLUDED',
  CANCELLED: 'CANCELLED',
  IN_OPERATION: 'IN_OPERATION',
  COMPLETED_BEFORE_TARGET: 'COMPLETED_BEFORE_TARGET',
  COMPLETED_WITH_TARGET_UPDATES: 'COMPLETED_WITH_TARGET_UPDATES',
  LOADING: 'LOADING',
  STOPPED: 'STOPPED'
};
var CustomCompletedBeforeTargetIcon = function CustomCompletedBeforeTargetIcon() {
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    position: "absolute",
    left: 2,
    top: 2,
    bottom: 0,
    width: "50%",
    height: "80%",
    bgcolor: "rgba(0, 150, 136, 0.3)",
    borderRadius: "50px 0 0 50px",
    zIndex: 1
  }), /*#__PURE__*/_react["default"].createElement(_iconsMaterial.CheckCircleOutline, {
    style: {
      position: 'relative',
      zIndex: 2,
      color: '#2FB259'
    }
  }));
};
var CustomCompletedWithTargetUpdatesIcon = function CustomCompletedWithTargetUpdatesIcon() {
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    position: "absolute",
    right: 2,
    top: 2,
    bottom: 0,
    width: "50%",
    height: "80%",
    bgcolor: "rgba(0, 150, 136, 0.3)",
    borderRadius: "0 50px 50px 0",
    zIndex: 1
  }), /*#__PURE__*/_react["default"].createElement(_iconsMaterial.CheckCircleOutline, {
    style: {
      position: 'relative',
      zIndex: 2,
      color: '#2FB259'
    }
  }));
};
var BATCH_STATUS_MAP = exports.BATCH_STATUS_MAP = new Map([[BATCH_STATUS_ENUM.COMPLETED, {
  icon: /*#__PURE__*/_react["default"].createElement(_iconsMaterial.CheckCircleOutlineOutlined, null),
  color: '#2FB259'
}], [BATCH_STATUS_ENUM.CONCLUDED, {
  icon: /*#__PURE__*/_react["default"].createElement(_iconsMaterial.CheckCircleOutlineOutlined, null),
  color: '#2FB259'
}], [BATCH_STATUS_ENUM.CANCELLED, {
  icon: /*#__PURE__*/_react["default"].createElement(_iconsMaterial.CancelOutlined, null),
  color: '#F13309'
}], [BATCH_STATUS_ENUM.IN_OPERATION, {
  icon: /*#__PURE__*/_react["default"].createElement(_iconsMaterial.RotateRightOutlined, null),
  color: '#397CCA'
}], [BATCH_STATUS_ENUM.COMPLETED_BEFORE_TARGET, {
  icon: /*#__PURE__*/_react["default"].createElement(CustomCompletedBeforeTargetIcon, null),
  color: '#2FB259'
}], [BATCH_STATUS_ENUM.COMPLETED_WITH_TARGET_UPDATES, {
  icon: /*#__PURE__*/_react["default"].createElement(CustomCompletedWithTargetUpdatesIcon, null),
  color: '#2FB259'
}], [BATCH_STATUS_ENUM.LOADING, {
  icon: /*#__PURE__*/_react["default"].createElement(_iconsMaterial.PendingOutlined, null),
  color: '#397CCA'
}], [BATCH_STATUS_ENUM.STOPPED, {
  icon: /*#__PURE__*/_react["default"].createElement(_iconsMaterial.PauseCircleOutlined, null),
  color: '#5C35AE'
}]]);
var getBatchStatusIcon = exports.getBatchStatusIcon = function getBatchStatusIcon(status) {
  var _ref = BATCH_STATUS_MAP.get(status) || {},
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#000000' : _ref$color;
  return /*#__PURE__*/_react["default"].cloneElement(icon, {
    style: {
      color: color
    }
  });
};